import React, { useEffect, useContext, useState, useCallback } from "react";
import { Image } from "uikit-react";
import { AppContexts } from "../../../providers";

import { host } from "../../../http.js";

const AirbnbIntegration = () => {
  const { settings, set, active } = useContext(AppContexts.SettingsContext);
  const { accounts, getAccounts, disconnectAccount } = useContext(
    AppContexts.AirbnbContext,
  );

  const [confirmDisconnect, setConfirmDisconnect] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [accountEmail, setAccountEmail] = useState("");
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    getAccounts();
  }, []);

  const handleConnect = async () => {
    let errs = [];

    if (!accountName.trim()) {
      errs.push("name");
    }

    if (!accountEmail.trim()) {
      errs.push("email");
    }

    if (errs.length > 0) {
      setErrors(errs);
      return;
    }

    window.location.assign(
      `${host}/v2/airbnb/auth/url?account_name=${accountName.trim()}&account_email=${accountEmail.trim()}`,
    );
  };

  const handleDisconnect = async (id) => {
    console.log(id);
    disconnectAccount(id);
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <li
      className={`setting-tab-content ${
        active === "integrations" ? "uk-active" : ""
      }`}
    >
      <div className="integrations-detail-content airbnb-connection-page">
        {/* Title */}
        <div className="uk-flex uk-flex-between uk-flex-top uk-margin-bottom">
          <div>
            <h2>Airbnb Connections</h2>
            <p className="uk-text-muted uk-margin-small-top">
              Connect one or more Airbnb accounts to sync properties,
              reservations, and guest information.
            </p>
          </div>
          <img
            src="/images/integration-logos/airbnb-logo.svg"
            alt="Airbnb"
            className="airbnb-title-logo"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>

        {/* Summary Bar */}
        {accounts.length > 0 && (
          <div className="airbnb-summary-bar uk-margin-bottom">
            <div className="airbnb-summary-stat">
              <span uk-icon="icon: users; ratio: 0.8"></span>
              <div>
                <div className="airbnb-summary-label">Accounts</div>
                <div className="airbnb-summary-value">{accounts.length}</div>
              </div>
            </div>
          </div>
        )}

        {/* Account Cards */}
        <div className="airbnb-accounts-list">
          {accounts.map((account, idx) => (
            <div key={account.id} className={`airbnb-account-card connected`}>
              <div className="airbnb-account-card-inner">
                <div className="uk-flex uk-flex-middle" style={{ gap: 14 }}>
                  <div>
                    <div className="uk-flex uk-flex-middle" style={{ gap: 8 }}>
                      <span className="airbnb-account-name">
                        {account.name}
                      </span>
                      <span className={`integration-badge connected`}>
                        Connected
                      </span>
                    </div>
                    <div className="airbnb-account-meta uk-margin-xsmall-top">
                      {account.email && (
                        <span className="airbnb-account-email">
                          {account.email}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="airbnb-account-actions">
                  {confirmDisconnect === account.id ? (
                    <div className="airbnb-confirm-disconnect">
                      <span className="airbnb-confirm-text">Remove?</span>
                      <button
                        className="uk-button hms-btn hms-red-btn btn-no-margin"
                        type="button"
                        onClick={() => handleDisconnect(account.id)}
                      >
                        Yes
                      </button>
                      <button
                        className="uk-button hms-btn hms-white-btn btn-no-margin"
                        type="button"
                        onClick={() => setConfirmDisconnect(null)}
                      >
                        No
                      </button>
                    </div>
                  ) : (
                    <button
                      className="uk-button hms-btn hms-red-outline-btn btn-no-margin"
                      type="button"
                      onClick={() => setConfirmDisconnect(account.id)}
                    >
                      <span
                        uk-icon="icon: trash; ratio: 0.7"
                        className="uk-margin-small-right"
                      ></span>
                      Disconnect
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Add Account Form / Button */}
        {showAddForm ? (
          <div className="airbnb-add-form uk-margin-bottom">
            <div className="hms-headings uk-margin-bottom">
              Connect a new Airbnb account
            </div>
            <div className="uk-grid uk-grid-small uk-margin-bottom" uk-grid>
              <div className="uk-width-1-2">
                <label className="uk-form-label">Account Name *</label>
                <div className="uk-form-controls">
                  <input
                    className="uk-input"
                    type="text"
                    value={accountName}
                    onChange={(e) => setAccountName(e.target.value)}
                    placeholder="e.g. Beach House Portfolio"
                  />
                </div>
              </div>
              <div className="uk-width-1-2">
                <label className="uk-form-label">
                  Airbnb Email <span className="uk-text-muted">(optional)</span>
                </label>
                <div className="uk-form-controls">
                  <input
                    className="uk-input"
                    type="email"
                    value={accountEmail}
                    onChange={(e) => setAccountEmail(e.target.value)}
                    placeholder="host@example.com"
                  />
                </div>
              </div>
            </div>
            <div className="uk-flex" style={{ gap: 10 }}>
              <button
                className="uk-button hms-btn hms-gray-btn btn-no-margin"
                type="button"
                onClick={handleConnect}
              >
                Connect Account
              </button>
              <button
                className="uk-button hms-btn hms-white-btn btn-no-margin"
                type="button"
                onClick={() => {
                  setShowAddForm(false);
                  setAccountName("");
                  setAccountEmail("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <button
            className="airbnb-add-account-btn uk-margin-bottom"
            type="button"
            onClick={() => setShowAddForm(true)}
          >
            <span uk-icon="icon: plus; ratio: 0.8"></span>
            {accounts.length === 0
              ? "Connect Airbnb Account"
              : "Add Another Account"}
          </button>
        )}

        {/* Empty State */}
        {accounts.length === 0 && !showAddForm && (
          <div className="airbnb-empty-state uk-margin-bottom">
            <img
              src="/images/integration-logos/airbnb-logo.svg"
              alt=""
              className="airbnb-empty-logo"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <div className="hms-headings">No Airbnb accounts connected</div>
            <p className="uk-text-muted uk-margin-small-top">
              Connect your Airbnb accounts to start syncing properties,
              reservations, and guest data with RueBaRue.
            </p>
          </div>
        )}
      </div>
    </li>
  );
};

export default AirbnbIntegration;
